import { SET_MODE } from './../constants/actionTypes'

export const setModeAction = data => dispatch => {
  dispatch({
    type: SET_MODE,
    data
  })
}
